module.exports = {
	"articleTitle1": "CEO: Insomnia Cookies to hopefully return within year",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Insomnia Cookies",
	"articleLink1": "https://www.michigandaily.com/news/insomnia-cookie-truck-gone-ann-arbor",
	"articleLink2": "https://www.michigandaily.com/news/insomnia-cookies-leases-space-south-universityformer-borders-office-space-bought",
	"articleSnippet1": "Jan 6, 2012 ... While Stucchi's on South University Ave. continues to sell a limited variety of \nInsomnia Cookies during their normal hours of operation, the ...",
	"articleSnippet2": "Apr 2, 2012 ... Popular cookie vendor Insomnia Cookies signed a lease last month to move into \nthe space formerly occupied by Yogo Bliss on South ...",
	"foodRecommendations": [
		{
			"text": "Warm cookies and cold ice cream make for some killer ice cream sandwiches.",
			"person": "Nick Kortman"
		},
		{
			"text": "Delicious.",
			"person": "Charlie Ruiz"
		}
	],
	"articleTitle2": "Insomnia Cookies leases space on South University",
	"address": "1229 S University Ave, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.275157,
		"lng": -83.733583
	},
	"totalMisc": 0,
	"categories": {
		"dessert": 1,
		"fooddrink": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/insomnia.json
// module id = 895
// module chunks = 0